import styled, { css } from "styled-components";
import searchIcon from "images/search-24px.svg";
import searchHoverIcon from "images/search-24px-hover.svg";
import { media } from "../../../../../components/common/media";
import homePageBg from "images/page-bg-circles.png";

export const HeroBackground = styled.div`
  position: relative;
  padding-bottom: 50px;
  background-size: cover;
  background-image: url(${homePageBg});
  .pilar-container,
  .pilar-container-tablet {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;
    padding: 0 80px 0px 80px;
  }
  .pilar-container-tablet {
    display: none;
  }

  .pilar-row {
    display: flex;
    width: 1730px;
    justify-content: center;
    align-items: flex-start;
    gap: 20px;
    margin-top: 200px;
  }

  @media screen and (max-width: 763px) {
    background-position-x: -1524px;
    background-position-y: 57px;
    background-size: auto;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 1023px) {
    height: 100%;
    .pilar-row {
      flex-direction: column;
      align-items: center;
      padding: 0px 15px;
      margin-top: 90px;
    }
    .pilar-row {
      width: auto;
    }
    .pilar-container,
    .pilar-container-tablet {
      padding: 0;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .pilar-container-tablet {
      display: flex;
    }
    .pilar-row-tablet {
      flex-direction: row;
    }
    .pilar-container {
      display: none;
    }
  }
`;

export const HeroContainer = styled.div`
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)) no-repeat 50%;
  ${(props) =>
    props.backgroundImage &&
    css`
      background-image: url(${(props) => props.backgroundImage});
    `}
  background-size: cover !important;
  height: 376px;
  position: relative;
  background-position-y: center;
  width: 90%;   
  margin:  auto;
  top: 100px;
  padding: 30px 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.55);
  background-blend-mode: multiply;
  .hero-title-mobile {
    display:none;
  }
  .title-highlight {
    color: ${(props) => props.theme.colors.primary.electricBlue};
  }

  .lt-cta {
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.6);
    text-align: center;
    padding: 15px 10px 0;
    p {
      color: ${(props) => props.theme.colors.primary.contrast};
      font-size: 20px;
      line-height: 125%;
      span,
      a {
        color: ${(props) => props.theme.colors.primary.main}
      }
    }
  }

  .wire-hero {
    p {
      font-size: 15px !important;
      font-weight: normal !important;
      span {
        color: ${(props) => props.theme.colors.primary.contrast};
        font-weight: 700;
        text-decoration: underline;
      }
    }
  }

  .popular-categories {
    display: flex;
      align-items: center;
      gap: 10px;
      justify-content: center;
      padding-top: 20px;
    h5 {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: 100%
      margin: 0;
    }
  }

  .search-homepage {
    padding: 0;
  }

  .layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 425px;
  }

  .callout {
    position: relative;
    width: 100%;
    max-width: 701px;
    margin: 0 auto;
    transition: all 0.6s ease 0s;
    h1 {
      color: ${(props) => props.theme.colors.primary.contrast};
      text-align: center;
      font-family: Mulish;
      font-size: 50px;
      font-style: normal;
      font-weight: 700;
      line-height: 125%;
      letter-spacing: 1px;
      padding-bottom: 20px;
      margin: 0;
      width: 100%;
      text-align: center;
      ${media.tablet`
        font-size: 35px;
        color: #FFF;
        text-align: center;
        font-family: Mulish;
        font-size: 35px;
        font-style: normal;
        font-weight: 700;
        line-height: 125%;
        padding: 0;
      `};
    }

    form {
       display: flex;
        max-width: 701px;
        height: 55px;
        align-items: center;
        gap: 15px;
        box-sizing: content-box;
        
      input {
        max-width: 701px;
        height: 55px;
            color: ${(props) => props.theme.colors.primary.spanishGray} !important;
            border-radius: 6px;
      }

    

      input[type="search"] {
        height: 52px;
        background: ${(props) => props.theme.colors.primary.contrast};
        padding-left: 15px;
        padding-right: 15px;
        border-right: 0;
        font-size: 14px;
        color: ${(props) => props.theme.colors.primary.charcoal};
        border-radius: 0;
        &.error {
          border: 2px solid ${(props) => props.theme.colors.primary.main};
        }

        ${media.phone`
          font-size: 12px;
        `};
      }

      input[type="submit"] {
        background: url(${searchIcon}) center center no-repeat ${(props) =>
  props.theme.colors.primary.contrast};
        height: 52px;
        color: ${(props) => props.theme.colors.primary.contrast};
        width: 60px;
        font-size: 16px;
        transition: all 0.6s ease 0s;
        margin-left: -1px;
        border: 1px solid #ced4da;
        border-left: 0;
        &:hover {
          background-image: url(${searchHoverIcon});
        }
        ${media.desktop`
          border-radius: 0;
          border: 1px solid #ced4da;
        `};
      }
    }

    p.searchError {
      padding-top: 2px;
      text-align: left;
      margin-left: 0;
      position: absolute;
    }
  }

  .search-tags {
    display: flex;
    margin-top: 25px;
    position: relative;
    ${media.desktop`
      display: block;
    `}
    button {
      background: none;
      border: 1px solid ${(props) => props.theme.colors.primary.contrast};
      color: ${(props) => props.theme.colors.primary.contrast};
      margin-right: 10px;
      margin-bottom: 10px;
      height: 30px;
      transition: all 0.6s ease 0s;
      &:hover {
        border: 1px solid ${(props) => props.theme.colors.primary.main}
        background: ${(props) => props.theme.colors.primary.main}
      }
    }
    a {
      position: absolute;
      right: 0;
      top: -20px;
      ${media.desktop`
        display: none;
      `}
      &.tags {
        position: relative;
        right: 0;
        ${media.desktop`
          display: inline-block;
        `}
      }
    }
  }
  a.advanceSearch {
    color: ${(props) => props.theme.colors.primary.contrast};
    transition: all 0.6s ease 0s;
    font-size: 16px;
    font-weight: 400;
    line-height: 30px;
    text-decoration: underline;
    &:hover {
      color: ${(props) => props.theme.colors.primary.main}
    }
  }
  .search-all-mobile {
    display: none;
    text-align: center;
    margin-top: 25px;
    ${media.desktop`
      display: block;
    `}
  }
  .popular-categories-container {
    display: flex;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 5px;
    align-self: stretch;
  }
@media screen and (max-width: 1023px) {
    top: 70px;
  }
  @media screen and (max-width: 763px) {
    background-image: none;
  }
  @media screen and (max-width: 991px) {
    background-position: center;
  }
   @media screen and (max-width: 1024px) {
    height: 100%;
    display: flex;
    padding: 0;
    margin: auto;
    padding: 30px 15px;
    .popular-categories {
      flex-direction: column;
    }
       
  .hero-title-desktop {
    display:none;
  }
   .hero-title-mobile-container {
    padding: 14px 0px 24px 0;
  }
   .hero-title-mobile {
    display:block;
  }
   }
   @media screen and (max-width: 370px) {
   .popular-categories-container {
    flex-wrap: wrap;
  }
  }
  }
`;
